import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@auth/services/auth.service';

import { IApplication } from '@shared/interfaces/applications.interface';
import { IUser } from '@shared/interfaces/user.interface';
import { filter, map } from 'rxjs/operators';
import { ApplicationService } from '../../../core/services/apps.service';

// Ngrx Store
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/app.reducers';
import { LOAD_APPS } from '@core/store/actions';
import { GeneralService } from '@shared/services/general.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  selectedIndex: number = 0;
  selectedUrl: string = null;
  user: IUser = null;
  applications: IApplication[] = null;

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private authService: AuthService,
    public generalService: GeneralService,
  ) {}

  ngOnInit() {
    this.store.select('auth').subscribe((auth) => (this.user = auth.user));
    this.getApplicationsToMenu();
    this.routeActived();
    this.getDataUser();
  }

  routeActived() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((path) => path['url']),
      )
      .subscribe((url) => {
        this.selectedUrl = url;
      });
  }

  getApplicationsToMenu() {
    this.store.dispatch(LOAD_APPS());
    this.store.select('apps').subscribe((store) => {
      this.applications = JSON.parse(JSON.stringify(store.apps));
      let x = [];
      x = [...this.applications];
      x.map((val: any) => {
        if (val.modulos) {
          val.modulos.map((g: any) => {
            g.acceso = false;
            this.user?.accesos.map((permisos) => {
              if (permisos.path === g.path) {
                g.acceso = true;
              }
            });
          });
        }
        val.acceso_aplicacion = false;
        this.user?.accesos.map((permisos) => {
          if (permisos.path.includes(val.path)) {
            val.acceso_aplicacion = true;
          }
        });
      });
    });
  }
  toggleAcordionMenuApps(indexApp: number) {
    this.applications[indexApp].open = !this.applications[indexApp].open;
  }
  toggleItem(indexApp, j) {
    this.applications[indexApp].modulos[j].open = !this.applications[indexApp].modulos[j].open;
  }
  async getDataUser() {
    await this.authService.getUserBySortKey();
  }
}
